module.exports = __webpack_public_path__ + "fonts/icomoon.00204f7.eot";